<app-report-sub-menu *ngIf="overViewMenu?.length" [menuList]="overViewMenu" [activeTab]="currentScroll"
    (menuChangeValue)="menuChangeValue($event)">
</app-report-sub-menu>


<ng-container *ngFor="let main_container of PowerBIData.pb_container">
    <div class="items report-tabsection" [ngClass]="{ 'scroll': currentScroll == main_container.sort_order}"
        id="{{ main_container.sort_order }}" [class.col1]="main_container.items.length == 1"
        [class.col2]="main_container.items.length == 2" [class.col3]="main_container.items.length == 3"
        [class.col4]="main_container.items.length == 4">
        <ng-container *ngFor="let item of main_container.items">
            <div class="item-card" [style]="{ width: main_container.width || '100%', height: main_container.height || '260px'}">
                <div [attr.id]="'visualOne' + item?.visualId" class="visual-one" style="width: 100%; height:100%">
                </div>
            </div>
        </ng-container>
        <div class="loading-gif" *ngIf="main_container?.loader">
          <img src="../../../../../../../assets/images/loading.gif" alt="" height="150px">
        </div>
    </div>
</ng-container>
